import Components from '../../Components';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/onboarding',
  exact: true,
  name: 'navigation.menu.onboarding',
  private: true,
  type: containerTypes.PAGE,
};

export default RouteConfig;
